import { createContext, useContext, useState, useEffect } from "react";
import api from "../services/api";
import { scheduleRefresh } from "../utils/auth";

const AuthContext = createContext();

export function AuthProvider({ children }) {
  const [token, setToken] = useState(() => localStorage.getItem("accessToken"));
  const [user, setUser] = useState(null);

  useEffect(() => {
    if (token) {
      const decoded = parseJwt(token);
      setUser(decoded);
    }
  }, [token]);

  const login = (accessToken) => {
    localStorage.setItem("accessToken", accessToken);
    setToken(accessToken);
    scheduleRefresh(accessToken);
  };

const logout = async () => {
  try {
    await api.post("/api/auth/logout", {}, { withCredentials: true });
  } catch (err) {
    console.error("Logout failed:", err);
  }

  localStorage.removeItem("accessToken");
  setToken(null);
  setUser(null);
};


const parseJwt = (token) => {
  try {
    if (!token || typeof token !== "string" || token.split(".").length !== 3) {
      console.warn("Invalid JWT format");
      return null;
    }
    return JSON.parse(atob(token.split('.')[1]));
  } catch (e) {
    console.error("Failed to parse JWT:", e);
    return null;
  }
};


  return (
    <AuthContext.Provider value={{ token, user, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  return useContext(AuthContext);
}
